import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import {firestore, user as AppUser, storage} from '@enigma/core/services';
import { AppContext } from '../../contexts/app';
import { UserContext } from '../../contexts/user';
import Stylesheet from './Menu.module.css';
import Classnames from 'classnames';
import { ico_cog, ico_question_circle, ico_file_alt,
    ico_cloud, ico_sort_down, ico_table, ico_user, ico_bars, ico_database } from '../../icon';
// TEMPORARY IMPORTS
import Progress from '../../elements/Progress/Progress';
import Image from '../../elements/Image/Image';
import Default from '../../assets/logo.jpg';

const Page = (props) => 
<div className={Classnames(Stylesheet.Page, {
[Stylesheet['New']]: props.new,
[Stylesheet['End']]: props.end})}>
    <Link to={`/${props.collection}/${props?.metadata?.name}`}>
        <div className={Stylesheet.Icon}>
            <svg width="2" height="59" viewBox="0 0 2 59" 
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 -0.00105286V59.0011" stroke="black" 
            strokeOpacity="0.2"/></svg>
            {props?.icon ? <h4>{props.icon}</h4> : <p></p>}
        </div>
        <div className={Stylesheet.Metadata}>
            <h5 className={Stylesheet.Text}>{props?.metadata?.name}</h5>
            <h6 className={Stylesheet.Status}>{props?.metadata?.description}</h6>
        </div>
    </Link>
</div>

const Drop = (props) => {
    const [active, setActive] = useState(false);
    return (
        <div className={Classnames(Stylesheet.Drop, {
        [Stylesheet['DropActive']]: active})}>
            <div className={Stylesheet.Title} 
            onClick={_ => setActive(active ? false : true)}>
                <div className={Stylesheet.Icon}>
                    <svg  xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 -0.00105286V59.0011" stroke="black" 
                    strokeOpacity="0.2"/></svg>
                    <h4>{props.icon}<span className={Stylesheet.New}>
                    </span></h4>
                </div>
                <div className={Stylesheet.Metadata}>
                    <h5 className={Stylesheet.Text}>{props.title}</h5>
                </div>
                <p className={Stylesheet.Indicator}>{ico_sort_down}</p>
            </div>
            <div className={Stylesheet.Pages}>
                {props?.collection
                ? props.collection.map((metadata, index) => 
                (<Page metadata={metadata} 
                    key={index} 
                    collection={props.title}
                    end={index === (props.collection.length - 1)}/>))
                : props.children}
            </div>
        </div>
    )
}

const Menu = (props) => {
    const [quota, setQuota] = useState({
        total_used: 0,
        total_available: 0
    });
    const [tables, setTables] = useState([]);
    const [forms, setForms] = useState([]);
    const metadata = (doc) => 
        {return {...doc.data(), id: doc.id}}
    const findIndex = (array, eid) => 
        {return array.findIndex(({id}) => id === eid)}
    const sync = (collection, array, update) => {
        return firestore.collection(collection)
        .onSnapshot(snap => {
            const changes = snap.docChanges();
            let newArray = array;
            for (const change of changes) {
                if (change.type === 'added') 
                    newArray.push(metadata(change.doc))
                if (change.type === 'modified') 
                    newArray[findIndex(array, change.doc.id)] = metadata(change.doc)
                if (change.type === 'removed')
                    newArray.splice(findIndex(array, change.doc.id), 1)
            }
            // update menu item
            update(newArray);
        })
    }
    useEffect(() => {
        // listen table changes
        const tableLisnter = sync('tables', tables, setTables);
        //listen to form changes
        const formsLisnter = sync('forms', forms, setForms);
        //listen to storage changes
        storage.onQuotaUpdated((quota => setQuota(quota)))
        // detach lisnter
        return function cleanup() { tableLisnter(); formsLisnter(); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <AppContext.Consumer>
            {app => (
                <UserContext.Consumer>
                    {user => (
                        <React.Fragment>
                        <div className={Classnames(Stylesheet.Overlay, {
                            [Stylesheet['DockedOverlay']]: app.config.dockedMenu })}
                            onClick={_ => app.toggleMenu()}></div>
                            <div className={Classnames(Stylesheet.Container, {
                            [Stylesheet['Docked']]: app.config.dockedMenu })}>
                                <div className={Stylesheet.Brand}>
                                    <div className={Stylesheet.Menu} 
                                    onClick={_ => app.toggleMenu()}>
                                        <h3>{ico_bars}</h3>
                                    </div>
                                    <h3>{ico_database}&emsp;fleet</h3>
                                </div>
                                <div className={Stylesheet.Profile}>
                                    <div className={Stylesheet.Img}>
                                        <Image src={Default} 
                                        url='static' alt={`${AppUser.displayName}`} />
                                    </div>
                                    <div className={Stylesheet.Metadata}>
                                        <h4 className={Stylesheet.DisplayName}>
                                        {AppUser.displayName}</h4>
                                        <h4 className={Stylesheet.Email}>
                                        {AppUser.email}</h4>
                                        <h5 className={Stylesheet.Role}>
                                        {user?.profile?.branch} &middot; {user?.profile?.role}</h5>
                                    </div>
                                </div>
                                <div className={Stylesheet.Links}>
                                    <Drop icon={ico_user} title='account'>
                                        <Page collection='account' 
                                        metadata={{name: 'profile', 
                                        description: "manage your user profile",
                                        id: 'profile'}} />
                                        <Page collection='account'
                                        metadata={{name: 'notifications', 
                                        description: "view your notifications",
                                        id: 'notifications'}}  end/>
                                    </Drop>
                                    
                                    <Drop icon={ico_table} title='tables' collection={tables} />
                                    <Drop icon={ico_file_alt} title='forms' collection={forms} />
                                    
                                    {user.profile?.admin
                                    ? <Drop icon={ico_cog} title='settings'>
                                        <Page collection='settings' 
                                        metadata={{name: 'accounts', 
                                        description: "manage user accounts",
                                        id: 'accounts'}} />
                                        <Page collection='settings'
                                        metadata={{name: 'tables', 
                                        description: "manage tables",
                                        id: 'tables'}} />
                                        <Page collection='settings' 
                                        metadata={{name: 'forms', 
                                        description: "manage forms",
                                        id: 'forms'}} end/>
                                    </Drop>
                                    : null}
                                    
                                    <Drop icon={ico_question_circle} title='help'>
                                        <Page collection='help' 
                                        metadata={{name: 'license', 
                                        description: "view software license and version information",
                                        id: 'profile'}} end/>
                                    </Drop>
                                </div>
                                <hr className={Stylesheet.Separator}/>
                                <div className={Stylesheet.Storage}>
                                    <div className={Stylesheet.Title}>
                                        <h4>{ico_cloud}</h4>
                                        <h5>storage quota</h5>
                                    </div>
                                    <div className={Stylesheet.Quota}>
                                        <div className={Stylesheet.Bar}>
                                            <Progress complete={(quota.total_used/quota.total_available)*100} />
                                        </div>
                                        <div className={Stylesheet.Metadata}>
                                            <h6>{(quota.total_used/1_000_000_000).toPrecision(1)} gb used</h6>
                                            <h6>{(5000000000/1_000_000_000)} gb total</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </UserContext.Consumer>
            )}
        </AppContext.Consumer>
    )
}

export default Menu;